module.exports = __webpack_public_path__ + "4a1d0eac91ae9a73a10852935f951011.svg";